<app-page-grid [title]="'restaurantes'" [type]="'restaurants'"></app-page-grid>